const MAPS_SRC =
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyD8rYcx-BzS-ulgWsvreyODukMPBhI2kjg&libraries=places&language=it';

let loaderPromise = null;

// Carica l'API di Google Maps una sola volta. Il consent manager (iubenda)
// puo' bloccare e re-iniettare lo script: per questo si controlla sempre se
// window.google.maps e' gia' disponibile e si attende con un polling.
const loadGoogleMaps = () => {
    if (window.google && window.google.maps) {
        return Promise.resolve(window.google.maps);
    }

    if (loaderPromise) {
        return loaderPromise;
    }

    loaderPromise = new Promise((resolve, reject) => {
        const ready = () => {
            if (window.google && window.google.maps) {
                resolve(window.google.maps);
                return true;
            }
            return false;
        };

        let script = document.querySelector(`script[src="${MAPS_SRC}"]`);

        if (!script) {
            script = document.createElement('script');
            script.src = MAPS_SRC;
            script.async = true;
            document.head.appendChild(script);
        }

        script.addEventListener('load', ready);
        script.addEventListener('error', () => {
            loaderPromise = null;
            reject(new Error('Impossibile caricare Google Maps API'));
        });

        // Fallback: se lo script viene bloccato e poi re-iniettato dal consent
        // manager, l'evento load non arriva sul nodo originale.
        const interval = setInterval(() => {
            if (ready()) {
                clearInterval(interval);
            }
        }, 300);
    });

    return loaderPromise;
};

export default loadGoogleMaps;
